import React from 'react';

const MainPage = () => {
    return (
        <div>
            Готовим для вас удобный способ общения с пациентами.<br></br>
            Скоро все диалоги будут здесь, и вы сможете легко отвечать!
        </div>
    );
};

export default MainPage;